import React from "react";

import 'katex/dist/katex.min.css';
import Latex from 'react-latex-next';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import benchmarktable from "../assets/results/SciML.png";
import cno_pred from "../assets/results/CNO_pred.png";
import l2 from "../assets/results/L2.png";
import linf from "../assets/results/Linfinity.png";
import loss from "/Users/samundrakarki/personal_website/research_website/src/assets/results/deeponet_loss.png";
import mse from "../assets/results/mse.png";


// import easy and har from assets/results/
import cno_easy from "../assets/results/cno_easy.png";
import cno_hard from "../assets/results/cno_hard.png";
import fno_easy from "../assets/results/fno_easy.png";
import fno_hard from "../assets/results/fno_hard.png";
import deeponet_easy from "../assets/results/deeponet_easy.png";
import deeponet_hard from "../assets/results/deeponet_hard.png";
import geometric_easy from "../assets/results/geo-deeponet_easy.png";
import geometric_hard from "../assets/results/geo-deeponet_hard.png";
import poseidon_easy from "../assets/results/poseidon_easy.png";
import poseidon_hard from "../assets/results/poseidon_hard.png";
import scot_easy from "../assets/results/scot_easy.png";
import scot_hard from "../assets/results/scot_hard.png";
import wno_easy from "../assets/results/wno_easy.png";
import wno_hard from "../assets/results/wno_hard.png";
// create an array of objects with src and alt properties for images of field
const images = [
  { src: cno_easy, alt: "CNO Easy", description: "Convolutional Neural Operator: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: cno_hard, alt: "CNO Hard", description: "Convolutional Neural Operator: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" },
  { src: fno_easy, alt: "FNO Easy", description: "Fourier Neural Operator: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: fno_hard, alt: "FNO Hard", description: "Fourier Neural Operator: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" },
  { src: deeponet_easy, alt: "DeepONet Easy", description: "DeepONet: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: deeponet_hard, alt: "DeepONet Hard", description: "DeepONet: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" },
  { src: geometric_easy, alt: "Geometric DeepONet Easy", description: "Geometric DeepONet: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: geometric_hard, alt: "Geometric DeepONet Hard", description: "Geometric DeepONet: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" },
  { src: poseidon_easy, alt: "Poseidon Easy", description: "Poseidon: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: poseidon_hard, alt: "Poseidon Hard", description: "Poseidon: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" },
  { src: scot_easy, alt: "SCOT Easy", description: "SCOT: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: scot_hard, alt: "SCOT Hard", description: "SCOT: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" },
  { src: wno_easy, alt: "WNO Easy", description: "Wavelet Neural Operator: Prediction vs. Ground Truth and Error for u,v,p. (Easy)" },
  { src: wno_hard, alt: "WNO Hard", description: "Wavelet Neural Operator: Prediction vs. Ground Truth and Error for u,v,p. (Hard)" }
];

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "gray", borderRadius: "50%", right: "-25px", zIndex: 2 }}
      onClick={onClick}
    />
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "gray", borderRadius: "50%", left: "-25px", zIndex: 2 }}
      onClick={onClick}
    />
  );
};

const ImageGallery = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: dots => (
      <div>
        <ul style={{ margin: "0px" }}> {dots} </ul>
        <br />
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Slider {...settings}>
      {images.map((image, index) => (
        <div key={index} style={{ padding: '0 1rem', margin: '0 1rem', boxSizing: 'border-box' }}>
          <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '8px', background: '#fff' }}>
            <img src={image.src} alt={image.alt} style={{ width: "100%", marginTop: "1rem" }} />
            <p style={{ textAlign: 'center', fontStyle: 'italic', fontFamily: "Times New Roman" }}>{image.description}</p>
          </div>
        </div>
      ))}
    </Slider>
  );
};
const Results = () => {
  return (
    <section className="pt-2">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div style={{ marginTop: "2rem" }}>
              
              <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
                <span className="greeting" style={{ fontSize: "2rem", fontFamily: "Times New Roman" }}>Benchmark Results</span>
              </div>
              <br />
              <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>
              <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>
              We report baseline results on training a suite of the most common neural PDE solvers. We studied the following (neural operator) frameworks and report results on the 2D LDC-NS: (a) Fourier Neural Operator (FNO) [1], (b) Convolutional Neural Operators (CNO) [2], (c) DeepONet [3], (d) Geometric DeepONet [4], (e) Wavelet Neural Operator (WNO) [5], (f) scOT [6], and (g) poseidon [6]. All models were trained on a single A100 80GB GPU, batch size 8, Adam optimizer, and run for 400 epochs.               </p>
              </p>
              <div style={{ textAlign: "center" }}>
                <p><Latex> In addition to MSE, we now also include $L_2$ and $L_\infty$ metrics, which have been used in fluids literature, and are defined as: </Latex></p>
                <Latex>
                  {`$$
                  L_2 = \\sqrt{\\frac{\\sum_{i = 1}^{n}(y - y^{'})^{2}}{\\sum_{i = 1}^{n} y^{'2}}} \\quad \\text{(L}_2 \\text{ relative error)}
                  $$`}
                </Latex>
                <Latex>
                  {`$$
                  L_\\infty  = \\frac{\\max \\left| y - y^{'} \\right|}{\\max \\left| y^{'} \\right|} \\quad \\text{(L}_\\infty \\text{ relative error)}
                  $$`}
                </Latex>
                <Latex>
                  {`$$
                  y = \\texttt{predicted solution} \\quad \\text{and} \\quad y^{'} = \\texttt{ground truth}
                  $$`}
                </Latex>
              </div>
              <p style={{ color: "#540", fontSize: "1rem", textAlign: "justify", textAlignLast: "center" }}>
               We use 2 different test/train splits (Standard and Hard). The Standard split is a random 80-20 split, where the training set is further divided into 80-20 training and validation subsets. The Hard split is an extrapolatory split, where the 10% of data with the lowest Reynolds numbers and the 10% with the highest Reynolds numbers are reserved for the testing set, while the remaining data is split randomly into training and validation sets using the standard 80-20 approach. </p>
  
              <br /><br />  
              <img src={mse} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily: "Times New Roman"  }}>The mean squared errors of various neural operators trained on the 2D LDC dataset at two different difficulty levels (Easy and Hard). All errors are reported on the testing dataset.</p>
              <br /><br />
              <img src={l2} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily: "Times New Roman"  }}><Latex>The relative $L_2$ error of various neural operators trained on the 2D LDC dataset at two different difficulty levels (Easy and Hard). All metrics are reported on the testing dataset.</Latex></p>
              <br /><br />
              <img src={linf} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily: "Times New Roman"  }}><Latex>The relative $L_\infty$ error of various neural operators trained on the 2D LDC dataset at two different difficulty levels (Easy and Hard). All metrics are reported on the testing dataset.</Latex></p>
              <br /><br />
              <img src={loss} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily: "Times New Roman"  }}> DeepONet: Total training and validation loss.</p>

              <br /><br />
              {/* <img src={mse} alt="GIF" style={{ maxWidth: "40%", marginTop: "1rem" }} />
              <br /><br />

              <p style={{ textAlign: 'center', fontStyle: 'italic', fontFamily: "Times New Roman" }}>
                The mean squared errors of CNO and FNO neural operators trained on the 2D LDC dataset at two resolutions. All errors are reported on the validation dataset. We denote by * the cases in which our implementations diverged. 0+ indicates an error value comparable to machine precision.
              </p> */}
              
              {/* <br /><br /> */}
              
              <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
                <span className="greeting" style={{ fontSize: "2rem", fontFamily: "Times New Roman" }}>Field Predictions</span>
              </div>
              {/* <img src={cno_pred} alt="GIF" style={{ maxWidth: "60%", marginTop: "1rem" }} />
              <p style={{ textAlign: 'center', fontStyle: 'italic',fontFamily: "Times New Roman"  }}> Convolutional Neural Operator: Prediction vs. Ground Truth and Error for u,v,p.</p>

              <br /><br /> */}
              <ImageGallery />
              <div style={{ backgroundColor: "#e0e0e0", color: "#000", padding: "1rem", borderRadius: "0.5rem" }}>
                <span className="greeting" style={{ fontSize: "2rem", fontFamily: "Times New Roman",fontStyle: 'italic' }}>References</span>
              </div>
              <div style={{ textAlign: "left", marginTop: "1rem" }}>
                <p>[1] Li, Z., Kovachki, N., Azizzadenesheli, K., Liu, B., Bhattacharya, K., Stuart, A., & Anandkumar, A. (2021). Fourier Neural Operator for Parametric Partial Differential Equations. arXiv preprint arXiv:2010.08895.</p>
                <p>[2] Raonić, B., Molinaro, R., De Ryck, T., Rohner, T., Bartolucci, F., Alaifari, R., Mishra, S., & de Bézenac, E. (2023). Convolutional Neural Operators for robust and accurate learning of PDEs. arXiv preprint arXiv:2302.01178.</p>
                <p>[3] Lu, L., Jin, P., Pang, G., Zhang, Z., & Karniadakis, G. E. (2021). Learning nonlinear operators via DeepONet based on the universal approximation theorem of operators. Nature Machine Intelligence, 3, 218–229.</p>
                <p>[4] He, Junyan, et al. "Geom-DeepONet: A point-cloud-based deep operator network for field predictions on 3D parameterized geometries." Computer Methods in Applied Mechanics and Engineering 429 (2024): 117130.</p>
                <p>[5] Tripura, Tapas, and Souvik Chakraborty. "Wavelet neural operator for solving parametric partial differential equations in computational mechanics problems." Computer Methods in Applied Mechanics and Engineering 404 (2023): 115783.</p>
                <p>[6] Herde, Maximilian, et al. "Poseidon: Efficient Foundation Models for PDEs." arXiv preprint arXiv:2405.19101 (2024).</p>
              </div>

            </div>

            <div>
              <span className="greeting-designation"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Results;
